import { render, staticRenderFns } from "./Descuento_nuevo.vue?vue&type=template&id=6963e72a&scoped=true"
import script from "./Descuento_nuevo.vue?vue&type=script&lang=js"
export * from "./Descuento_nuevo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6963e72a",
  null
  
)

export default component.exports